import { render } from "./CollectionDetailedSearch.vue?vue&type=template&id=ce1e57ba&scoped=true&ts=true"
import script from "./CollectionDetailedSearch.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearch.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearch.vue?vue&type=style&index=0&id=ce1e57ba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce1e57ba"]])

export default __exports__